import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    time: String,
    format: String
  }

  connect() {
    const locationTimeZone = document.body.dataset.locationTimezone || "UTC"
    const date = new Date(this.timeValue)

    const options = this.formatOptions(this.formatValue)
    options.timeZone = locationTimeZone

    let formatted = date.toLocaleString("en-US", options)

    if (locationTimeZone === "UTC") {
      formatted += " UTC"
    }

    this.element.textContent = formatted
  }

  formatOptions(format) {
    switch (format) {
      case "short":
        return { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }
      case "medium":
        return { dateStyle: "medium", timeStyle: "long" }
      case "long":
        return { dateStyle: "long", timeStyle: "long" }
      case "time":
        return { hour: "numeric", minute: "2-digit" }
      default:
        return { dateStyle: "medium", timeStyle: "short" }
    }
  }
}
